import { render, staticRenderFns } from "./ResearchMPlot.vue?vue&type=template&id=0ffd734a"
import script from "./ResearchMPlot.vue?vue&type=script&lang=js"
export * from "./ResearchMPlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ffd734a')) {
      api.createRecord('0ffd734a', component.options)
    } else {
      api.reload('0ffd734a', component.options)
    }
    module.hot.accept("./ResearchMPlot.vue?vue&type=template&id=0ffd734a", function () {
      api.rerender('0ffd734a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchMPlot.vue"
export default component.exports